import { createContext, useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

const WorkQueueTabSwitchContext = createContext(null);

export const WorkQueueTabSwitchProvider = ({ children }) => {
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const prevPresetRef = useRef(null);

  const isTabSwitch = useCallback(
    (queueType) => {
      return preset === queueType && prevPresetRef.current !== preset;
    },
    [preset]
  );

  useEffect(() => {
    prevPresetRef.current = preset;
  }, [preset]);

  const value = useMemo(() => ({ isTabSwitch, preset }), [isTabSwitch, preset]);

  return (
    <WorkQueueTabSwitchContext.Provider value={value}>
      {children}
    </WorkQueueTabSwitchContext.Provider>
  );
};

WorkQueueTabSwitchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useWorkQueueTabSwitch = () => {
  const context = useContext(WorkQueueTabSwitchContext);
  if (!context) {
    throw new Error('useWorkQueueTabSwitch must be used within WorkQueueTabSwitchProvider');
  }
  return context;
};
